import React, { useEffect, useState } from "react";
import EmployerLayout from "./Common/EmployerLayout";
import { useDispatch, useSelector } from "react-redux";
import { FetchJobTypes } from "../../../Redux/Slices/JobType";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { FetchIndustries } from "../../../Redux/Slices/Industry";
import { FetchSkill } from "../../../Redux/Slices/Skill";
import { FetchQualifications } from "../../../Redux/Slices/Qualification";
import { yearOption, thousandOption, lacOption } from "../../../Helper/Option";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Location from "../../Admin/Location";
import { PostJob } from "../../../Redux/Slices/JobPost";
import { GetUserSubscriptions } from "../../../Redux/Slices/Package";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Common/Sidebar";
import {
  getJobPostingAccessStatus,
  JOB_POSTING_ACCESS_MESSAGES,
} from "../../../Helper/subscriptionHelper";
import toast from "react-hot-toast";
import { FaArrowLeft, FaArrowRight, FaCheck } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const STEPS = [
  { id: 1, label: "Job Details" },
  { id: 2, label: "Requirements" },
  { id: 3, label: "Compensation & Apply" },
];

const FormField = ({ label, required, error, children, className = "" }) => (
  <div className={`employer-form-group ${className}`}>
    {label && (
      <label className="employer-form-label">
        {label}
        {required && (
          <span style={{ color: "var(--employer-danger)" }}> *</span>
        )}
      </label>
    )}
    {children}
    {error && <span className="employer-error-text">{error}</span>}
  </div>
);

const JobPost = () => {
  const role = localStorage.getItem("role");
  const [error, setError] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [remainingQuota, setRemainingQuota] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const { jobTypesData } = useSelector((state) => state?.JobType);
  const { industriesData } = useSelector((state) => state?.Industry);
  const { skillsData } = useSelector((state) => state?.Skill);
  const { qualificationsData } = useSelector((state) => state?.Qualification);
  const [startDate, setStartDate] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [postDetails, setPostDetails] = useState({});
  const [applicationMode, setApplicationMode] = useState("");
  const [selectedqualification, setselectedqualification] = useState([]);
  const [selectedSkills, setselectedSkills] = useState([]);
  const [selectedIndustries, setselectedIndustries] = useState("");
  const [text, setText] = useState("");
  const [locationData, setLocationData] = useState({
    Country: "",
    State: [],
    States: [],
    Cities: [],
  });

  const selectedStates = Array.isArray(locationData?.States)
    ? locationData.States
    : Array.isArray(locationData?.State)
      ? locationData.State
      : locationData?.State
        ? [locationData.State]
        : [];

  const animatedComponents = makeAnimated();

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "48px",
      border: state.isFocused
        ? "2px solid var(--employer-primary)"
        : "1px solid var(--employer-border)",
      borderRadius: "8px",
      background: "#fff",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(72, 147, 179, 0.12)" : "none",
    }),
    placeholder: (provided) => ({ ...provided, color: "#94a3b8", fontSize: "14px" }),
    multiValue: (provided) => ({
      ...provided,
      background: "var(--employer-primary)",
      borderRadius: "6px",
    }),
    multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "13px" }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "white",
      ":hover": { background: "rgba(255,255,255,0.2)", color: "white" },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    }),
  };

  const options = skillsData?.docs?.map((item) => ({
    value: item.name,
    label: item.name,
    id: item._id,
  }));
  const options2 = qualificationsData.map((item) => ({
    value: item.name,
    label: item.name,
    id: item._id,
  }));
  const options3 = industriesData?.docs?.map((item) => ({
    value: item.name,
    label: item.name,
    id: item._id,
  }));

  const handleSelectChange = (qualification) => {
    setselectedqualification(qualification.map((option) => option.id));
    clearFieldError("qualification");
  };
  const handleSelectChange2 = (skills) => {
    setselectedSkills(skills.map((option) => option.id));
    clearFieldError("skills");
  };
  const handleSelectChange3 = (industry) => {
    setselectedIndustries(industry?.id || "");
    clearFieldError("industry");
  };

  const isDescriptionEmpty = (value) => {
    if (!value) return true;
    return value.replace(/<[^>]*>/g, "").trim().length === 0;
  };

  const clearFieldError = (field) => {
    setError((prev) => {
      if (!prev?.[field]) return prev;
      const updated = { ...prev, [field]: "" };
      delete updated.general;
      const hasErrors = Object.entries(updated).some(
        ([key, val]) => key !== "general" && val
      );
      return hasErrors ? updated : {};
    });
  };

  const validateStep = (step) => {
    const stepErrors = {};

    if (step === 1) {
      if (!postDetails.jobtype) stepErrors.jobtype = "Job Type is required";
      if (!postDetails.jobtitle?.trim())
        stepErrors.jobtitle = "Job Title is required";
      if (!postDetails.company_name?.trim())
        stepErrors.company_name = "Company Name is required";
      if (isDescriptionEmpty(text))
        stepErrors.description = "Job Description is required";
      if (!postDetails.category) stepErrors.category = "Job Category is required";
    }

    if (step === 2) {
      if (!locationData?.Country) stepErrors.location = "Country is required";
      else if (!selectedStates.length)
        stepErrors.location = "At least one State is required";
      else if (!locationData?.Cities?.length)
        stepErrors.location = "At least one City is required";
      if (!selectedIndustries) stepErrors.industry = "Industry is required";
      if (!selectedSkills?.length)
        stepErrors.skills = "At least one Skill is required";
      if (!selectedqualification?.length)
        stepErrors.qualification = "At least one Qualification is required";
      if (
        !postDetails.exp_from ||
        !postDetails.exp_to ||
        postDetails.exp_from === "All" ||
        postDetails.exp_to === "All"
      ) {
        stepErrors.experience = "Experience Range is required";
      }
    }

    if (step === 3) {
      if (postDetails?.ctcdisplay === "true" || postDetails?.ctcdisplay === true) {
        if (!postDetails.ctc_from_lacs || !postDetails.ctc_to_lacs) {
          stepErrors.ctc = "CTC Range is required";
        }
      }
      if (!startDate) stepErrors.validity = "Job Validity Date is required";
      if (!applicationMode) stepErrors.apply_through = "Apply Through is required";
      if (applicationMode === "Form" && !postDetails.form_link?.trim()) {
        stepErrors.form_link = "Form Link is required";
      }
    }

    if (Object.keys(stepErrors).length > 0) {
      stepErrors.general =
        "Please fill all mandatory fields marked with * before proceeding.";
    }

    return stepErrors;
  };

  const postUserData = (e) => {
    const { name, value } = e.target;
    if (value) clearFieldError(name === "company_name" ? "company_name" : name);
    setPostDetails({ ...postDetails, [name]: value });
  };

  const handleChange = (value) => {
    setText(value);
    if (!isDescriptionEmpty(value)) clearFieldError("description");
  };

  const receiveDataFromChild = (data) => {
    setLocationData(data);
    const states = Array.isArray(data?.States)
      ? data.States
      : Array.isArray(data?.State)
        ? data.State
        : data?.State
          ? [data.State]
          : [];
    if (data?.Country && states.length && data?.Cities?.length) {
      clearFieldError("location");
    }
  };

  const handleapplied = (e) => {
    setApplicationMode(e.target.value);
    clearFieldError("apply_through");
  };

  const scrollToFormTop = () => {
    document
      .getElementById("job-post-form-top")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleNext = () => {
    const stepErrors = validateStep(currentStep);
    setError(stepErrors);
    if (Object.keys(stepErrors).length > 0) {
      scrollToFormTop();
      return;
    }
    setError({});
    setCurrentStep((prev) => Math.min(prev + 1, 3));
    scrollToFormTop();
  };

  const handleBack = () => {
    setError({});
    setCurrentStep((prev) => Math.max(prev - 1, 1));
    scrollToFormTop();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const stepErrors = validateStep(3);
    setError(stepErrors);
    if (Object.keys(stepErrors).length > 0) {
      scrollToFormTop();
      return;
    }

    if (role === "Employer") {
      const subData = await GetUserSubscriptions();
      const access = getJobPostingAccessStatus(subData?.subscriptions);
      if (!access.canPost) {
        toast.error(JOB_POSTING_ACCESS_MESSAGES[access.reason]);
        navigate("/employer/package");
        return;
      }
    }

    setSubmitting(true);
    const data = {
      type: postDetails?.jobtype,
      title: postDetails?.jobtitle,
      company_name: postDetails?.company_name,
      about_company: postDetails?.about_company,
      description: text,
      country: locationData?.Country,
      cities: locationData?.Cities,
      state: selectedStates,
      industry: selectedIndustries,
      skills: selectedSkills,
      qualification: selectedqualification,
      other_skill: postDetails?.other_skills,
      exp: {
        from: postDetails?.exp_from,
        to: postDetails?.exp_to,
      },
      ctc: {
        from_lac: postDetails?.ctc_from_lacs,
        from_thousand: postDetails?.ctc_from_thousand,
        to_lac: postDetails?.ctc_to_lacs,
        to_thousand: postDetails?.ctc_to_thousand,
      },
      ctc_display: postDetails?.ctcdisplay,
      validity: startDate
        ? `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`
        : startDate,
      apply_through: applicationMode,
      form_link: postDetails?.form_link,
      website_link: postDetails?.website_link,
      category: postDetails?.category,
    };

    const res = await PostJob(data);
    setSubmitting(false);

    if (res?.response) {
      const msg = res?.response?.data?.message || "";
      const isSubscriptionIssue =
        res?.response?.data?.subscription === false ||
        /subscription|balance are used|job postings balance/i.test(msg);

      if (isSubscriptionIssue) {
        toast.error(msg || JOB_POSTING_ACCESS_MESSAGES.no_subscription);
        navigate("/employer/package");
        return;
      }
    }

    if (res?.success && role === "Employer") {
      navigate("/employer/posted-jobs");
      return;
    }
    if (res?.success && role === "Admin") {
      navigate("/admin/postedjobs");
    }
  };

  useEffect(() => {
    const data = { page: 1, search: "", limit: 50 };
    dispatch(FetchJobTypes());
    dispatch(FetchIndustries(data));
    dispatch(FetchSkill(data));
    dispatch(FetchQualifications());
    document.title = "Post Job | CAJobPortal";
  }, [dispatch]);

  useEffect(() => {
    if (role !== "Employer") return;

    GetUserSubscriptions().then((data) => {
      const access = getJobPostingAccessStatus(data?.subscriptions);
      if (access.canPost) setRemainingQuota(access.remaining);
    });
  }, [role]);

  const filteredJobTypes = jobTypesData?.filter((value) => {
    const name = value?.name?.toLowerCase().trim();
    if (role === "Admin") return name !== "thirdparty listing";
    if (role === "Employer") return name === "thirdparty listing";
    return false;
  });

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={["Employer", "Post Job"]}>
        <div className="employer-page-header">
          <div>
            <h1 className="employer-page-title">Post New Job</h1>
            <p style={{ color: "var(--employer-text-muted)", marginTop: "0.25rem" }}>
              Complete all steps to publish your job opening
            </p>
          </div>
        </div>

        {role === "Employer" && remainingQuota !== null && (
          <div className="employer-job-post-quota">
            <FaCheck /> {remainingQuota} job posting{remainingQuota !== 1 ? "s" : ""} remaining
          </div>
        )}

        <div className="employer-card" style={{ maxWidth: "920px", margin: "0 auto" }}>
          <div className="employer-card-body">
            <div className="employer-job-post-steps">
              {STEPS.map((step) => (
                <div
                  key={step.id}
                  className={`employer-job-post-step ${
                    currentStep === step.id
                      ? "active"
                      : currentStep > step.id
                      ? "completed"
                      : ""
                  }`}
                >
                  <span className="employer-job-post-step-number">
                    {currentStep > step.id ? <FaCheck size={12} /> : step.id}
                  </span>
                  <span>{step.label}</span>
                </div>
              ))}
            </div>

            <form className="job-post-form" onSubmit={handleSubmit}>
              <div id="job-post-form-top">
                {error.general && (
                  <div className="employer-form-error-banner" role="alert">
                    {error.general}
                  </div>
                )}
              </div>

              {currentStep === 1 && (
                <div className="employer-form-section">
                  <h3 className="employer-form-section-title">Basic Job Information</h3>

                  <FormField label="Job Type" required error={error.jobtype}>
                    <select
                      name="jobtype"
                      value={postDetails.jobtype || ""}
                      onChange={postUserData}
                      className="employer-form-input"
                    >
                      <option value="">Select Job Type</option>
                      {filteredJobTypes?.map((value) => (
                        <option key={value._id} value={value._id}>
                          {value.name}
                        </option>
                      ))}
                    </select>
                  </FormField>

                  <div className="employer-form-grid-2">
                    <FormField label="Job Title" required error={error.jobtitle}>
                      <input
                        name="jobtitle"
                        value={postDetails.jobtitle || ""}
                        onChange={postUserData}
                        type="text"
                        className="employer-form-input"
                        placeholder="e.g. Senior Accountant"
                      />
                    </FormField>
                    <FormField label="Company Name" required error={error.company_name}>
                      <input
                        name="company_name"
                        value={postDetails.company_name || ""}
                        onChange={postUserData}
                        type="text"
                        className="employer-form-input"
                        placeholder="Company name"
                      />
                    </FormField>
                  </div>

                  <FormField label="About Company" error={error.about_company}>
                    <textarea
                      name="about_company"
                      value={postDetails.about_company || ""}
                      onChange={postUserData}
                      rows={3}
                      className="employer-form-input"
                      placeholder="Brief overview of the company"
                    />
                  </FormField>

                  <FormField label="Job Description" required error={error.description}>
                    <ReactQuill theme="snow" value={text} onChange={handleChange} />
                  </FormField>

                  <FormField label="Job Category" required error={error.category}>
                    <select
                      name="category"
                      value={postDetails.category || ""}
                      onChange={postUserData}
                      className="employer-form-input"
                    >
                      <option value="">Select Job Category</option>
                      <option value="Temporary">Temporary</option>
                      <option value="Permanent">Permanent</option>
                      <option value="Freelance">Freelance</option>
                    </select>
                  </FormField>
                </div>
              )}

              {currentStep === 2 && (
                <div className="employer-form-section">
                  <h3 className="employer-form-section-title">Location & Requirements</h3>

                  <FormField label="Location" required error={error.location}>
                    <Location
                      sendDataToParent={receiveDataFromChild}
                      multiState
                      multiCity
                    />
                  </FormField>

                  <div className="employer-form-grid-2">
                    <FormField label="Industry" required error={error.industry}>
                      <Select
                        styles={customSelectStyles}
                        components={animatedComponents}
                        options={options3}
                        onChange={handleSelectChange3}
                        placeholder="Select Industry"
                      />
                    </FormField>
                    <FormField label="Qualification" required error={error.qualification}>
                      <Select
                        styles={customSelectStyles}
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={options2}
                        onChange={handleSelectChange}
                        placeholder="Select Qualifications"
                      />
                    </FormField>
                  </div>

                  <FormField label="Skills" required error={error.skills}>
                    <div className="employer-form-grid-2">
                      <Select
                        styles={customSelectStyles}
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={options}
                        onChange={handleSelectChange2}
                        placeholder="Select Skills"
                      />
                      <input
                        type="text"
                        className="employer-form-input"
                        name="other_skills"
                        placeholder="Other skills (optional)"
                        onChange={postUserData}
                      />
                    </div>
                  </FormField>

                  <FormField label="Experience Range" required error={error.experience}>
                    <div className="employer-form-grid-2">
                      <select
                        name="exp_from"
                        value={postDetails.exp_from || ""}
                        onChange={postUserData}
                        className="employer-form-input"
                      >
                        <option value="">Min experience</option>
                        {yearOption?.map((value) => (
                          <option key={`from-${value}`} value={value}>
                            {value} Year{value !== 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                      <select
                        name="exp_to"
                        value={postDetails.exp_to || ""}
                        onChange={postUserData}
                        className="employer-form-input"
                      >
                        <option value="">Max experience</option>
                        {yearOption?.map((value) => (
                          <option key={`to-${value}`} value={value}>
                            {value} Year{value !== 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                  </FormField>
                </div>
              )}

              {currentStep === 3 && (
                <div className="employer-form-section">
                  <h3 className="employer-form-section-title">Compensation & Application</h3>

                  <FormField label="Display CTC on job listing?">
                    <div className="employer-radio-group">
                      <label className="employer-radio-option">
                        <input
                          type="radio"
                          name="ctcdisplay"
                          value="true"
                          checked={postDetails.ctcdisplay === "true" || postDetails.ctcdisplay === true}
                          onChange={postUserData}
                        />
                        Yes
                      </label>
                      <label className="employer-radio-option">
                        <input
                          type="radio"
                          name="ctcdisplay"
                          value="false"
                          checked={postDetails.ctcdisplay === "false" || postDetails.ctcdisplay === false}
                          onChange={postUserData}
                        />
                        No
                      </label>
                    </div>
                  </FormField>

                  {(postDetails?.ctcdisplay === "true" || postDetails?.ctcdisplay === true) && (
                    <FormField label="CTC Range (in Lakhs)" required error={error.ctc}>
                      <p className="employer-form-help employer-mb-1">From</p>
                      <div className="employer-form-grid-2 employer-mb-2">
                        <select
                          name="ctc_from_lacs"
                          value={postDetails.ctc_from_lacs || ""}
                          onChange={postUserData}
                          className="employer-form-input"
                        >
                          <option value="">Lacs</option>
                          {lacOption?.map((value) => (
                            <option key={`from-lac-${value}`} value={value}>
                              {value} Lacs
                            </option>
                          ))}
                        </select>
                        <select
                          name="ctc_from_thousand"
                          value={postDetails.ctc_from_thousand || ""}
                          onChange={postUserData}
                          className="employer-form-input"
                        >
                          <option value="">Thousands</option>
                          {thousandOption?.map((value) => (
                            <option key={`from-th-${value}`} value={value}>
                              {value} Thousands
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="employer-form-help employer-mb-1">To</p>
                      <div className="employer-form-grid-2">
                        <select
                          name="ctc_to_lacs"
                          value={postDetails.ctc_to_lacs || ""}
                          onChange={postUserData}
                          className="employer-form-input"
                        >
                          <option value="">Lacs</option>
                          {lacOption?.map((value) => (
                            <option key={`to-lac-${value}`} value={value}>
                              {value} Lacs
                            </option>
                          ))}
                        </select>
                        <select
                          name="ctc_to_thousand"
                          value={postDetails.ctc_to_thousand || ""}
                          onChange={postUserData}
                          className="employer-form-input"
                        >
                          <option value="">Thousands</option>
                          {thousandOption?.map((value) => (
                            <option key={`to-th-${value}`} value={value}>
                              {value} Thousands
                            </option>
                          ))}
                        </select>
                      </div>
                    </FormField>
                  )}

                  <div className="employer-form-grid-2">
                    <FormField label="Job Validity" required error={error.validity}>
                      <DatePicker
                        className="employer-form-input"
                        placeholderText="Select expiry date"
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          clearFieldError("validity");
                        }}
                        minDate={new Date()}
                      />
                    </FormField>
                    <FormField label="Apply Through" required error={error.apply_through}>
                      <select
                        value={applicationMode}
                        className="employer-form-input"
                        onChange={handleapplied}
                      >
                        <option value="">Select Apply Through</option>
                        <option value="Resume">Resume</option>
                        <option value="Form">Form</option>
                        <option value="Website">Website</option>
                      </select>
                    </FormField>
                  </div>

                  {applicationMode === "Website" && (
                    <FormField label="Website Link">
                      <input
                        name="website_link"
                        value={postDetails.website_link || ""}
                        type="url"
                        className="employer-form-input"
                        placeholder="https://..."
                        onChange={postUserData}
                      />
                    </FormField>
                  )}

                  {applicationMode === "Form" && (
                    <FormField label="Form Link" required error={error.form_link}>
                      <input
                        name="form_link"
                        value={postDetails.form_link || ""}
                        type="url"
                        className="employer-form-input"
                        placeholder="https://..."
                        onChange={postUserData}
                      />
                    </FormField>
                  )}
                </div>
              )}

              <div className="employer-job-post-footer">
                {currentStep > 1 ? (
                  <button
                    type="button"
                    className="employer-btn employer-btn-secondary"
                    onClick={handleBack}
                  >
                    <FaArrowLeft /> Back
                  </button>
                ) : (
                  <span />
                )}

                {currentStep < 3 ? (
                  <button
                    type="button"
                    className="employer-btn employer-btn-primary"
                    onClick={handleNext}
                  >
                    Next <FaArrowRight />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="employer-btn employer-btn-primary"
                    disabled={submitting}
                  >
                    {submitting ? "Posting..." : "Post Job"}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </EmployerLayout>
    </div>
  );
};

export default JobPost;
